import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  active,
  align,
  className,
  icon,
  onClick,
  submit,
  tabIndex,
  text,
  type,
}) => {
  const buttonClassName = ['button'];

  if (type) {
    buttonClassName.push(`button--${type}`);
  }
  if (align) {
    buttonClassName.push(`button--${align}`);
  }
  if (active) {
    buttonClassName.push('button--enabled');
  } else {
    buttonClassName.push('button--disabled');
  }

  if (className) {
    buttonClassName.push(className);
  }

  const buttonProps = {};
  if (onClick && active) {
    buttonProps.onClick = onClick;
  }

  return (
    <button
      disabled={!active}
      type={submit ? 'submit' : 'button'}
      className={buttonClassName.join(' ')}
      tabIndex={tabIndex}
      {...buttonProps}
    >
      {icon}
      {text}
    </button>
  );
};

Button.propTypes = {
  active: PropTypes.bool,
  align: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  submit: PropTypes.bool,
  tabIndex: PropTypes.number,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
};

Button.defaultProps = {
  active: true,
  align: '',
  className: '',
  submit: false,
  tabIndex: 0,
  text: '',
  type: '',
};

export default Button;
